var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 75,
    viewBox: "0 0 78 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0591 14.1127L19.5591 28.2254L39.0591 42.3382L19.5591 56.4509L0 42.2042L19.5443 28.0915L0 14.1127L19.5443 0L39.0591 14.1127ZM19.4409 60.8873L38.9409 46.7746L58.4409 60.8873L38.9409 75L19.4409 60.8873ZM39.0591 42.2042L58.5591 28.0915L39.0591 14.096L58.4557 0L78 14.1127L58.4557 28.2254L78 42.3214L58.4557 56.4342L39.0591 42.2042Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageIcon);
export default __webpack_public_path__ + "static/media/package_icon.ea324a05c277acbf770b5e32054086a2.svg";
export { ForwardRef as ReactComponent };